<p-tablist>
  @for (tabPanel of tabPanelHeaders; track i; let i = $index) {
    <p-tab
      [value]="i"
      [disabled]="tabPanel?.disabled ?? false"
      (click)="onValueChange(i)">
      <div class="flex items-center gap-2">
        <span
          [ngClass]="{
            dp2: headerSize === 'default',
            sh2: headerSize === 'small',
          }"
          class="font-normal"
          >{{ tabPanel.header }}</span
        >
        @if (tabPanel.showCount) {
          <span class="count-badge">{{ tabPanel.count }}</span>
        }
      </div>
    </p-tab>
  }
</p-tablist>
<p-tabpanels>
  @for (tabPanel of tabPanelHeaders; track i; let i = $index) {
    <p-tabpanel [value]="i">
      @if (tabTemplates[i]) {
        <ng-template [ngTemplateOutlet]="tabTemplates[i]"></ng-template>
      }
    </p-tabpanel>
  }
</p-tabpanels>
